import React, { useState } from 'react';
import { IconCheckmark, IconCopy } from '@noths/polaris-client-ribbons-design-system';

import * as styles from './PromoCodeMessageButton.styles';

const COPIED_MESSAGE_DURATION = 1000;

interface PromoCodeMessageButtonProps {
  children: React.ReactNode;
  promoCode: string;
}

export const PromoCodeMessageButton = ({ children, promoCode }: PromoCodeMessageButtonProps) => {
  const [copied, setCopied] = useState<boolean>(false);
  const [hover, setHover] = useState<boolean>(false);

  const onButtonClick = async () => {
    try {
      await navigator.clipboard.writeText(promoCode);
      setCopied(true);
      setTimeout(() => setCopied(false), COPIED_MESSAGE_DURATION);
    } catch (error) {
      console.error('Failed to copy to clipboard', error);
    }
  };

  return (
    <button
      aria-label="Copy promo code to clipboard"
      css={styles.root}
      onBlur={() => setHover(false)}
      onClick={onButtonClick}
      onFocus={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      onMouseOver={() => setHover(true)}
      type="button"
    >
      {copied ? (
        <>
          Copied code <IconCheckmark color="var(--functional-green-base)" height={16} width={16} />
        </>
      ) : (
        <>
          {children}
          <IconCopy
            color={hover ? 'var(--functional-green-deep)' : 'var(--functional-green-base)'}
            height={16}
            width={16}
          />
        </>
      )}
    </button>
  );
};
